import React, { MouseEventHandler } from 'react';
import { StyledUnorderedList } from '@cp/ds/src/components/styled/styledUnorderedList';
import { ClientContactViewModel } from '@common/model/client';
import { ClientContact, ClientContactItemDict } from '../item';

export interface ClientContactListProps {
  contacts: ClientContactViewModel[];
  contactsConfig: ClientContactItemDict;
  isMasked?: boolean;
  onItemClick?: MouseEventHandler;
}

export const ClientContactList: React.FC<ClientContactListProps> = ({ contacts = [], contactsConfig, isMasked, onItemClick }) => {
  return (
    <StyledUnorderedList>
      {contacts.map((contact) => {
        const layoutData = contactsConfig[contact.type];
        if (!layoutData) {
          if (__DEV__) {
            console.error(`[ClientContactItem]: Metadata for contact type "${contact.type}" not found.`);
          }
          return null;
        }
        const { icon: Icon, label, linkResolver } = layoutData;
        return (
          <ClientContact
            sx={{ mb: 3.75 }}
            key={contact.id}
            icon={<Icon />}
            label={typeof label === 'function' ? label(contact) : label}
            href={!isMasked ? linkResolver(contact) : undefined}
            onClick={onItemClick}
          />
        );
      })}
    </StyledUnorderedList>
  );
};
